export default "__VITE_ASSET__62f24200__"